import { render } from "./IconLink.vue?vue&type=template&id=f30bd6ae"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f30bd6ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f30bd6ae', __exports__)) {
    api.reload('f30bd6ae', __exports__)
  }
  
  module.hot.accept("./IconLink.vue?vue&type=template&id=f30bd6ae", () => {
    api.rerender('f30bd6ae', render)
  })

}


export default __exports__